const getFixedTopHeight = () => {
  let maxBottom = 0;

  document.querySelectorAll('[data-fixed-top]').forEach((el) => {
    const style = window.getComputedStyle(el);

    if (style.position === 'fixed' && el.offsetHeight > 0) {
      const rect = el.getBoundingClientRect();

      if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
        maxBottom = Math.max(maxBottom, rect.bottom);
      }
    }
  });

  return maxBottom;
};

export const updateFixedNavHeight = () => {
  document.documentElement.style.setProperty('--fixed-nav-height', `${getFixedTopHeight()}px`);
};
